Number.prototype.discountDistinct = function(distinct) {
  if(distinct > 100 || distinct < 0) return this;

  return this * (100 - distinct) / 100;
};